
const state = () => ({
    reviews: [],
    stars: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 },
    selectedReview: {},
    selectedParent: {},
    avgRating:0,
    totalReviews:0,
    userIds:[],
    totalForCurrentRequest:0
});

const mutations = {
    setuserIds(state, userIds) {
        state.userIds = userIds;
    },
    settotalForCurrentRequest(state, totalForCurrentRequest) {
        state.totalForCurrentRequest = totalForCurrentRequest;
    },
    settotalReviews(state, totalReviews) {
        state.totalReviews = totalReviews;
    },
    setavgRating(state, avgRating) {
        state.avgRating = avgRating;
    },
    setReviews(state, reviews) {
        state.reviews = reviews;
    },
    setStars(state, stars) {
        state.stars = stars || { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    },
    setSelectedReview(state, review) {
        state.selectedReview = review;
    },
    addReview(state, review) {
        if (!state.stars) state.stars = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        state.stars[review.rating]++;
        state.reviews.unshift(review);
        state.totalReviews++
        state.totalForCurrentRequest++
        state.userIds.push(review.userId)
    },
    reviewRating(state,rating)
    {
        state.reviewRating = rating;
    },
    addToParent(state,review)
    {
        state.selectedParent.replies.unshift(review)
    },
    setParent(state,review)
    {
        state.selectedParent = review;
    },
    recalcRating(state)
    {
        let totalScore = 0;
        let totalReviews = 0;

        // Iterate over each key in the stars object
        for (let star in state.stars) {
            const rating = parseInt(star);  // Convert the star key to an integer
            const count = state.stars[star];      // Get the number of reviews for this star rating

            totalScore += rating * count;   // Add to the total score (rating * number of reviews)
            totalReviews += count;          // Add to the total number of reviews
        }

        // Calculate the average rating
        const averageRating = totalScore / totalReviews;

        // Handle the case where there are no reviews to avoid division by zero
        state.avgRating =  totalReviews === 0 ? 0 : averageRating.toFixed(2);
    },
    deleteReview(state, reviewToDelete) {
        state.reviews = state.reviews.filter(review => review.id != reviewToDelete.id);
        if (state.stars) state.stars[reviewToDelete.rating]--;
        state.totalReviews--
        state.totalForCurrentRequest--

        const index = state.userIds.indexOf(reviewToDelete.userId); // Find the index of the id in the array
        if (index !== -1) { // If the id is found in the array
            state.userIds.splice(index, 1); // Remove the id from the array
        }
    },
    deleteFromParentReview(state, reviewId) {

        state.selectedParent.replies = state.selectedParent.replies.filter(review => review.id != reviewId);
    },
};

const actions = {

};

const getters = {

};

export default({
    state,
    mutations,
    actions,
    getters
});
